import { render, staticRenderFns } from "./gift-package-modal.vue?vue&type=template&id=4051809d&scoped=true&"
import script from "./gift-package-modal.vue?vue&type=script&lang=js&"
export * from "./gift-package-modal.vue?vue&type=script&lang=js&"
import style0 from "./gift-package-modal.vue?vue&type=style&index=0&id=4051809d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4051809d",
  null
  
)

export default component.exports